<template>
    <div class="SchedulingChecklist">
        <div class="container-fluid">
            <div class="row">
                <div class="col" id="table">
                    <vuetable :fields="TableOptions.Fields"
                              :data="ChecklistData"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable"
                              ref="datatable">

                        <template slot="Check" scope="props">
                            <div class="Check">
                                <font-awesome-icon v-if="props.rowData.IsScheduled || props.rowData.OffWeekValue" :icon="['far', 'check-square']" class="olive-green-text" />
                                <font-awesome-icon v-else :icon="['far', 'square']" />
                            </div>
                        </template>
                        <template slot="OffWeek" scope="props">
                            <div class="OffWeek">
                                <b-form-checkbox v-model="props.rowData.OffWeekValue" name="check-button" switch @change="ToggleOffWeek(props.rowData)">

                                </b-form-checkbox>
                            </div>
                        </template>
                    </vuetable>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import { EventBus } from '../../../services/event-bus.js';


    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faCheckSquare } from '@fortawesome/free-solid-svg-icons';
    library.add(faCheckSquare);
    import { faSquare } from '@fortawesome/free-solid-svg-icons';
    library.add(faSquare);

    import Vuetable from 'vuetable-2/src/components/Vuetable'

    export default {
        created() {
        },
        data: function () {
            return {
                TableOptions: {
                    Fields: [
                        {
                            name: '__slot:Check',
                            title: '',
                        },
                        {
                            name: 'ClientName',
                            title: 'Name',
                        },
                        {
                            name: 'ServiceName',
                            title: 'Service',
                        },
                        {
                            name: 'ServiceFrequency',
                            title: 'Schedule',
                        },
                        {
                            name: '__slot:OffWeek',
                            title: 'OffWeek',
                        }
                    ]
                }
            };
        },
        props: [
            "ChecklistData"
        ],
        methods: {
            ToggleOffWeek(checklistData) {
                this.$MasterAPI.ExecuteRequest("POST", "Wraparound/ClientAppointments/ToggleOffWeek", checklistData, () => { }, this.RefreshCalendar, true);
            },
        },
        components: {
            Vuetable,
        },
        mounted() {

        },
        computed: {

        }
    }
</script>

<style scoped>
    #table{
        width: 100%;
        display: inline-block;
        overflow-x: auto;
    }
</style>